import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';
import { useIntl } from '@klokhuis/core/Intl';
import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';

const useMetaTags = (): { metaTitle: string; metaDescription: string } => {
  const { listingsState } = ListingsContext.useContext();
  const { filters } = listingsState.filterResult;
  const { T } = useIntl();
  const { location, listingTypeIds } = filters;
  const cityName = location?.cityName;
  const countryName = T('LBL_INDIA');
  const firstListingType = listingTypeIds?.[0];
  const isGenericSearch = listingTypeIds?.length !== 1;
  let metaTitle: string;
  let metaDescription: string;

  // street
  if (cityName) {
    if (isGenericSearch) {
      metaTitle = T(
        'listings_page.meta_tags.title.city.generic',
        cityName,
        countryName,
      );

      metaDescription = T(
        'listings_page.meta_tags.description.city.generic',
        cityName,
        countryName,
      );
    } else if (firstListingType === PropertyTypeID.ResidentialLand) {
      metaTitle = T(
        'listings_page.meta_tags.title.city.residential_land',
        cityName,
      );

      metaDescription = T(
        'listings_page.meta_tags.description.city.residential_land',
        cityName,
      );
    } else if (firstListingType === PropertyTypeID.HouseOrVilla) {
      metaTitle = T('listings_page.meta_tags.title.city.house', cityName);

      metaDescription = T(
        'listings_page.meta_tags.description.city.house',
        cityName,
      );
    } else if (firstListingType === PropertyTypeID.FarmLand) {
      metaTitle = T('listings_page.meta_tags.title.city.farm_land', cityName);

      metaDescription = T(
        'listings_page.meta_tags.description.city.farm_land',
        cityName,
      );
    } else if (firstListingType === PropertyTypeID.CommercialLand) {
      metaTitle = T(
        'listings_page.meta_tags.title.city.commercial_property',
        cityName,
      );

      metaDescription = T(
        'listings_page.meta_tags.description.city.commercial_property',
        cityName,
      );
    } else {
      metaTitle = T(
        'listings_page.meta_tags.title.city.generic',
        cityName,
        countryName,
      );

      metaDescription = T(
        'listings_page.meta_tags.description.city.generic',
        cityName,
        countryName,
      );
    }
  }
  // country
  else if (isGenericSearch) {
    metaTitle = T('listings_page.meta_tags.title.country.generic', countryName);

    metaDescription = T(
      'listings_page.meta_tags.description.country.generic',
      countryName,
    );
  } else if (firstListingType === PropertyTypeID.ResidentialLand) {
    metaTitle = T(
      'listings_page.meta_tags.title.country.residential_land',
      countryName,
    );

    metaDescription = T(
      'listings_page.meta_tags.description.country.residential_land',
      countryName,
    );
  } else if (firstListingType === PropertyTypeID.HouseOrVilla) {
    metaTitle = T('listings_page.meta_tags.title.country.house', countryName);

    metaDescription = T(
      'listings_page.meta_tags.description.country.house',
      countryName,
    );
  } else if (firstListingType === PropertyTypeID.FarmLand) {
    metaTitle = T(
      'listings_page.meta_tags.title.country.farm_land',
      countryName,
    );

    metaDescription = T(
      'listings_page.meta_tags.description.country.farm_land',
      countryName,
    );
  } else if (firstListingType === PropertyTypeID.CommercialLand) {
    metaTitle = T(
      'listings_page.meta_tags.title.country.commercial_property',
      countryName,
    );

    metaDescription = T(
      'listings_page.meta_tags.description.country.commercial_property',
      countryName,
    );
  } else {
    metaTitle = T('listings_page.meta_tags.title.country.generic', countryName);

    metaDescription = T(
      'listings_page.meta_tags.description.country.generic',
      countryName,
    );
  }

  return { metaTitle, metaDescription };
};

export default useMetaTags;
